import { useEffect, useState } from 'react';
import { Smartphone, X, Share } from 'lucide-react';

const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem('install-dismissed') === '1' || isStandalone());
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener('beforeinstallprompt', h); return () => window.removeEventListener('beforeinstallprompt', h);
  }, []);
  const mobile = window.matchMedia('(max-width: 900px)').matches;
  if (hidden || !mobile || (!evt && !isIos())) return null;
  const dismiss = () => { localStorage.setItem('install-dismissed', '1'); setHidden(true); };
  const install = async () => { if (!evt) return; evt.prompt(); const r = await evt.userChoice; if (r.outcome === 'accepted') setHidden(true); };
  return <div className="install-banner" data-testid="install-banner">
    <Smartphone size={16} />
    <p>{evt ? <><strong>Ana ekrana ekleyin.</strong> PatronSoft bir uygulama gibi tek dokunuşla açılsın.</> : <><strong>Ana ekrana ekleyin:</strong> Safari'de <Share size={12} /> Paylaş → "Ana Ekrana Ekle".</>}</p>
    {evt && <button type="button" className="primary-btn small" onClick={install} data-testid="install-button">Ekle</button>}
    <button type="button" className="icon-btn" onClick={dismiss} aria-label="Kapat" data-testid="install-dismiss"><X size={14} /></button>
  </div>;
}
